import React from "react";
import { Link } from "react-router-dom";

/**
 * Eine Kennzahl, die irgendwohin führt.
 *
 * Warum es diese Komponente gibt und nicht einfach ein <Link>: Die Karten, auf
 * denen diese Zahlen stehen — Entitätskarten im Dashboard und auf der
 * Entitätenseite — sind ziehbar, damit sich die Reihenfolge ändern lässt. Ein
 * gewöhnlicher Link darin verschluckt sich daran: Der Mauszeiger drückt, die
 * Karte nimmt das als Griff, und die Navigation passiert nie. Deshalb wehrt
 * dieser Link das Ziehen ausdrücklich ab.
 *
 * Ohne `href` bleibt alles wie zuvor — dann rendert sie schlicht ein <div>, und
 * die aufrufende Stelle muss keine Fallunterscheidung treffen.
 */
export const KachelLink = ({ href, title, className = "", children }) => (
    href ? (
        <Link
            to={href}
            title={title}
            draggable={false}
            onMouseDown={(ev) => ev.stopPropagation()}
            onDragStart={(ev) => ev.preventDefault()}
            onClick={(ev) => ev.stopPropagation()}
            className={`block -m-1 p-1 rounded hover:bg-gray-50 transition-colors ${className}`}
        >
            {children}
        </Link>
    ) : (
        <div className={className}>{children}</div>
    )
);

export default KachelLink;
